import { useState, useRef } from "react";

const ServiceSearchBar = ({ onSearch }) => {
  const [query, setQuery] = useState("");
  const inputRef = useRef(null); // 👈 ref for input

  const handleSearch = () => {
    if (!query.trim()) return;
    onSearch(query);
    setQuery("");
  };

  const handleContainerClick = () => {
    if (inputRef.current) {
      inputRef.current.focus(); // 👈 focus input on container click
    }
  };

  return (
    <div
      className="search-input-container service-search-bar"
      onClick={handleContainerClick} // 👈 catch clicks on container
    >
      <input
        ref={inputRef} // 👈 attach ref
        type="text"
        value={query}
        placeholder="Search services..."
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && handleSearch()}
      />
      <button
        className="search-btn"
        onClick={(e) => {
          e.stopPropagation(); // 👈 prevent container click from triggering focus again
          handleSearch();
        }}
      >
        <i className="fa-solid fa-magnifying-glass"></i>
      </button>
    </div>
  );
};

export default ServiceSearchBar;